import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import { Card, CardContent, CardHeader } from "components/ui";

const TermsAndConditionHistorySkeleton = memo(() => {
  return (
    <Card>
      <CardHeader className="flex flex-row m-5">
        <Skeleton variant="text" width={260} height={32} />
      </CardHeader>
      <CardContent className="py-3">
        {Array.from({ length: 5 }, (_, index) => (
          <div
            key={index}
            className="flex items-center justify-between border-b py-4"
          >
            <Skeleton variant="text" width="45%" height={24} />
            <Skeleton variant="circular" width={20} height={20} />
          </div>
        ))}
      </CardContent>
    </Card>
  );
});

TermsAndConditionHistorySkeleton.displayName =
  "TermsAndConditionHistorySkeleton";

export default TermsAndConditionHistorySkeleton;
